import React, { useEffect } from 'react';
import { getProcessIcon } from './ProcessIcons';
import { CloseIcon } from './Icons';

const ProcessModal = ({ process, onClose }) => {

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    
    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  const handleContactClick = () => {
    onClose();
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 300);
  };

  return (
    <div 
      className="project-modal-overlay active"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="project-modal process-modal">
        <button 
          className="project-modal-close" 
          onClick={onClose}
          aria-label="Close modal"
        >
          <CloseIcon />
        </button>

        {/* Header */}
        <div className="process-modal-header">
          <div className="process-modal-number">{process.number}</div>
          <div className="process-modal-icon">
            {getProcessIcon(process.iconName)}
          </div>
        </div>

        {/* Content */}
        <div className="project-modal-content">
          <span className="project-modal-category">{process.tagline}</span>
          <h2 className="project-modal-title">{process.title}</h2>

          <p className="project-modal-description">{process.fullDescription}</p>

          <div className="project-modal-details">
            <h4 className="project-modal-details-title">What Happens</h4>
            <ul className="project-modal-details-list">
              {process.whatHappens.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="process-modal-takeaway">
            <h4 className="project-modal-details-title">Client Takeaway</h4>
            <p>{process.clientTakeaway}</p>
          </div>

          <div className="project-modal-cta">
            <p>Ready to start your preservation journey?</p>
            <button 
              className="btn-primary-custom"
              onClick={handleContactClick}
            >
              Schedule a Consultation
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessModal;